import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Organization } from './models/organizations';

@Injectable()
export abstract class OrganizationService {
    abstract getOrganizations(): Observable<Organization[]>;

    abstract getOrganizationById(id: string): Observable<Organization | undefined>;
}
